import React from 'react'
import cn from 'classnames'

import { ReactComponent as Chevron } from '../../../assets/icons/back-chevron.svg'
import styles from './BackChevron.module.scss'

const BackChevron = ({ className, ...props }) => {
  const classNames = cn(styles.backChevron, className)

  return <Chevron className={classNames} {...props} />
}

export default BackChevron